import React, { Component } from 'react';
import { inject } from 'mobx-react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { maxWidth } from '../../helpers/media-queries';

const Dropdown = styled.div `
    margin: 5px 0;
    display: flex;
    justify-content: flex-end;
    position: relative;
    padding: 0 25px;
    
    .btn {
        border-radius: 0;
        color: #48C2C5;
        border: 0;
        border-bottom: 1px solid #48C2C5;
        text-transform: uppercase;
        background-color: transparent;
        font-family: 'zx_spectrum7_boldregular', sans;
        font-size: 2em;
        line-height: 0.5em;
        flex-direction: row;
        display: flex;
        align-items: center;
        padding-left: 0;
        padding-right: 0;
        &:after {
            font-size: 0.5em;
            margin-right: 1em;
        }
        &:hover, &:focus, &:active {
            background-color: transparent !important;
            color: #48C2C5 !important;
        }

        img {
        }
        
        &:before {
            width: 12px;
            height: 8px;
            margin-right: 7px;
            content: '';
            display: inline-block;
            background-image: url(./static/images/ranking/arrow.png);
            background-repeat: no-repeat;
            background-size: contain;
        }
    };
    
    .dropdown-menu {
        right: 0;
        left: auto;
        border-radius: 0;
        background-color: #48C2C5;
        box-shadow: 0px 5px 0px rgba(0,0,0,0.5);
    };
    
    .dropdown-menu button {
        font-family: 'zx_spectrum7_boldregular', sans;
        font-size: 2em;
        line-height: 0.5em;
        cursor: pointer;
        text-transform: uppercase;
        &:hover, &:focus, &:active {
            background-color: transparent !important;
            color: #ffffff !important;
            border: none;
        }
    }

    ${maxWidth.lg} {
        justify-content: center;
    }
`;

const styles = (props) => ({
});

const mapper = (stores) => ({
    intl: stores.intl.dictionary,
    country: stores.ranking.country,
    countries: stores.ranking.countries,
    setCountry: (id) => stores.ranking.setCountry(id),
})

class SelectCountry extends Component {
    state = {
        open: false,
    }
    render() {
        const { intl, countries, country = {} } = this.props;
        return (
            <Dropdown 
                className={classNames("dropdown")} >
                <button 
                    aria-label={intl['LOCALE.COUNTRY.LABEL']}
                    className="btn btn-secondary"
                    onClick={() => this.setState({ open: !this.state.open })}>
                    {intl[`LOCALE.IOC.${country.label}`]}
                </button>   
                
                <div 
                    className="dropdown-menu" 
                    aria-labelledby="dropdownMenuLink" 
                    style={{ display: this.state.open ? 'block' : 'none' }}>
                    {[...this._generateFields(countries)]}
                </div>
            </Dropdown>
        )
    }

    *_generateFields(content, type) {
        content = content || [];
        content = content.entries();

        for(const [i, entry] of content) {
            yield this._renderOption(`row-${type}-${i}`, entry);
        }
    }

    _renderOption = (key, content) => {
        const { intl, country } = this.props;
        // Keep references to named entries
        let ref = this.refs[key];
        if (!ref) {
            ref = React.createRef();
            this.refs = Object.assign({}, this.refs, { [key]: ref });
        }
        
        return (
            <button
                className={classNames("dropdown-item", {
                    selected: content.id === country.id
                })}
                key={key}
                ref={ref}
                onClick={() => this._onSelect(content.id)}>
                {intl[`LOCALE.IOC.${content.label}`]}
            </button>
        );
    }

    _onSelect = (value) => {
        const { setCountry } = this.props;
        setCountry && setCountry(+value);
        this.setState({ open: false });
    }
}

export default inject(mapper)(
    withStyles(styles)(SelectCountry)
);